<template>
  <div class="order-item">
    <div class="order-item-header">
      <p class="order-item-id van-ellipsis">
        订单编号：
        <span>{{ refund.orderId || refund.orderParentId }}</span>
      </p>
      <p class="yellow order-item-status">
        {{ refundStatusZhEnum[refund.refundStatus] }}
      </p>
    </div>
    <store-item
      :store="refund"
      :isPickOrder="refund.deliveryWay === 2"
      :shouldPay="false"
      :isShowStatus="false"
      :isCustomPageTo="true"
      @customPageTo="toRefundDetail"
      style="margin-bottom: 10px"
    >
      <goods-item class="goods-item" v-if="refund.goodsList.length === 1" :goods="refund.goodsList[0]"></goods-item>
      <!-- 退款单基于子订单发起，所以一个退款单里不存在多个供应商的商品，所以直接用 goodsNum -->
      <goods-list v-else :goodsList="refund.goodsList" :itemCount="refund.goodsNum || 0"></goods-list>
    </store-item>

    <section v-show="count" class="summary order-info">
      共{{ count }}件，合计 ¥
      <span class="order-info-price">{{ refund.refundPrice | price }}</span>
    </section>
  </div>
</template>
<script>
import { refundStatusZhEnum } from '@/constant/enum.js';

import storeItem from '@/components/storeItem.vue';
import goodsItem from '@/components/goodsItem.vue';
import goodsList from '@/components/goodsList.vue';
import price from '@/components/Price.vue';
export default {
  components: {
    storeItem,
    goodsItem,
    goodsList,
    price
  },
  props: {
    refund: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      refundStatusZhEnum
    };
  },
  computed: {
    count() {
      return this.refund.goodsNum || 0;
    },
    price() {
      return this.refund.refundPrice || '';
    }
  },
  methods: {
    renderClassByStatus(status) {
      const goryArr = [
        52, // 交易关闭
        22
      ];
      if (goryArr.includes(status)) return 'gory';
      return 'yellow';
    },
    toRefundDetail(refund) {
      this.$router.push('/refund/' + refund.refundId);
    }
  }
};
</script>
<style lang="less" scoped>
.order-item {
  color: #262626;
  font-size: 14px;
  background: #ffffff;
  padding: 20px 12px 0;
  border-radius: 8px;
  overflow: hidden;
  .goods-item {
    padding: 0;
  }
  &-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  &-id {
    flex: 1;
  }
  &-status {
    font-size: 12px;
    margin-left: 12px;
    &.gory {
      color: #bfbfbf;
    }
    &.yellow {
      color: #ff8200;
    }
  }
  .summary {
    text-align: right;
    padding-bottom: 16px;
    padding-top: 6px;
    font-size: 12px;
    .order-info-price {
      font-size: 16px;
    }
  }
}
.btn-wrapper {
  text-align: right;
  background: #ffffff;
  padding-bottom: 16px;
  margin-top: 4px;
  .btn {
    height: 32px;
  }
  .gory-btn {
    /deep/ .van-button__content {
      color: #595959;
    }
  }
  .btn-pay {
    width: 78px;
    height: 32px;
    border-radius: 8px;
    background: #1e8dff;
  }
}
.self-popup-box {
  background: transparent;
  .popup-container {
    width: 100%;
    padding: 36px 47px;
    background: #fff;
    border-radius: 12px;
    text-align: center;
    color: #262626;
    font-size: 14px;
    min-width: 270px;
    &-title {
      margin-bottom: 20px;
    }
    &-code {
      font-size: 32px;
      color: #1e8dff;
      font-weight: 500;
      margin-bottom: 32px;
    }
    &-time {
      width: 100%;
      font-size: 12px;
      color: #1e8dff;
      .label {
        color: #8c8c8c;
      }
    }
  }
}
</style>
